export default __webpack_public_path__ + "static/media/okIcon.cfd20eef.svg";